// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-fae5bece] {\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n.header[data-v-fae5bece] {\n  height: 80px !important;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  border-bottom: 1px solid #dbdbdb;\n}\n", ""]);
// Exports
module.exports = exports;
